// Product Catalog - Single source of truth for all products
// Generated by scripts/generate-product-catalog.py
// To add a product: add an object to the CATALOG array below

export const AFFILIATE_TAG = 'pickify0f-20';

export const VALID_CATEGORIES = [
  'tech', 'gaming', 'fashion', 'jewelry', 'beauty', 'grooming',
  'home', 'outdoor', 'sports', 'food', 'subscription'
];

export const CATALOG = [
  // === BEAUTY ===
  {
    id: 'chanel-no5',
    name: 'Chanel No. 5 Eau de Parfum',
    asin: 'B000VOJ9BG',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B000VOJ9BG._SL300_.jpg',
    price: 105.0,
    brand: 'Chanel',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'cuisinart-frozen-yogurt-ice-cream-maker',
    name: 'Cuisinart Frozen Yogurt & Ice Cream Maker',
    asin: null,
    amznLink: 'https://amzn.to/3MdpYkC',
    image: 'https://m.media-amazon.com/images/I/618bD19XIgL._AC_SL500_.jpg',
    price: 69.0,
    brand: 'Cuisinart',
    category: 'home',
    description: 'Make healthy, homemade frozen treats in 20 minutes. A fun activity for date night.',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'home', 'mothersday', 'valentines'],
    originalPrice: 99.95,
    salePrice: 69.0,
    discountPercent: 31,
    rating: 4.7,
    reviewCount: 20000,
    occasionValue: 'valentines',
  },
  {
    id: 'dior-sauvage',
    name: 'Dior Sauvage Eau de Toilette',
    asin: 'B01MY1SF77',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01MY1SF77._SL300_.jpg',
    price: 85.0,
    brand: 'Dior',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-50-100', 'christmas', 'boyfriend', 'him', 'dad', 'fathersday', 'valentines'],
  },
  {
    id: 'drunk-elephant-set',
    name: 'Drunk Elephant Skincare Set',
    asin: 'B0D3FGYDSS',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0D3FGYDSS._SL300_.jpg',
    price: 98.0,
    brand: 'Drunk',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'dyson-airwrap',
    name: 'Dyson Airwrap',
    asin: 'B0F96LDS27',
    amznLink: 'https://amzn.to/4tVoBIC',
    image: 'https://m.media-amazon.com/images/P/B0F96LDS27._SL300_.jpg',
    price: 0,
    brand: 'Dyson',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'esarora-ice-roller-for-face-eye',
    name: 'Esarora Ice Roller for Face & Eye',
    asin: null,
    amznLink: 'https://amzn.to/4a5iPuF',
    image: 'https://m.media-amazon.com/images/I/81UFIq8JPJL._SL500_.jpg',
    price: 12.0,
    brand: 'Esarora',
    category: 'beauty',
    description: 'A trending beauty tool for reducing puffiness and redness. A great, budget-friendly self-care gift.',
    tags: ['beauty', 'birthday', 'budget-under25', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 18.99,
    salePrice: 12.0,
    discountPercent: 37,
    rating: 4.7,
    reviewCount: 30000,
    occasionValue: 'valentines',
  },
  {
    id: 'glossier-cloud-paint',
    name: 'Glossier Cloud Paint',
    asin: 'B0DTV19G2W',
    amznLink: 'https://amzn.to/4amXIFD',
    image: 'https://m.media-amazon.com/images/P/B0DTV19G2W._SL300_.jpg',
    price: 0,
    brand: 'Glossier',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'glossier-milky-jelly-cleanser',
    name: 'Glossier Milky Jelly Cleanser',
    asin: 'B07DXPRLQQ',
    amznLink: 'https://amzn.to/3OLSaMl',
    image: 'https://m.media-amazon.com/images/P/B07DXPRLQQ._SL300_.jpg',
    price: 0,
    brand: 'Glossier',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'herbivore-lapis-face-oil',
    name: 'Herbivore Lapis Face Oil',
    asin: 'B01NCNJ4RO',
    amznLink: 'https://amzn.to/4qC0USz',
    image: 'https://m.media-amazon.com/images/P/B01NCNJ4RO._SL300_.jpg',
    price: 0,
    brand: 'Herbivore',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'jbl-flip-6',
    name: 'JBL FLIP 6',
    asin: 'B09V7WS4PP',
    amznLink: 'https://amzn.to/3OcRHCX',
    image: 'https://m.media-amazon.com/images/I/81nT721hWGL._SL300_.jpg',
    price: 0,
    brand: 'JBL',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 129.95,
    salePrice: 99.95,
    discountPercent: 23,
    rating: 4.8,
    reviewCount: 25000,
    occasionValue: 'valentines',
  },
  {
    id: 'la-mer-cream',
    name: 'La Mer Moisturizing Cream',
    asin: 'B00BH4KLJI',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00BH4KLJI._SL300_.jpg',
    price: 195.0,
    brand: 'La Mer',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'la-mer-treatment-lotion',
    name: 'La Mer Treatment Lotion',
    asin: 'B09C3FW2KH',
    amznLink: 'https://amzn.to/3Om6DP1',
    image: 'https://m.media-amazon.com/images/P/B09C3FW2KH._SL300_.jpg',
    price: 0,
    brand: 'La Mer',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'boyfriend', 'christmas', 'fathersday', 'girlfriend', 'her', 'him', 'mothersday', 'valentines'],
  },
  {
    id: 'laneige-lip-sleeping-mask',
    name: 'Laneige Lip Sleeping Mask',
    asin: null,
    amznLink: 'https://amzn.to/4keMeHp',
    image: 'https://m.media-amazon.com/images/I/51jipK28SOL._SL500_.jpg',
    price: 19.0,
    brand: 'Laneige',
    category: 'beauty',
    description: 'A viral leave-on lip mask that delivers intense moisture and antioxidants while you sleep for smooth, supple lips.',
    tags: ['beauty', 'birthday', 'budget-under25', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 24.0,
    salePrice: 19.0,
    discountPercent: 21,
    rating: 4.7,
    reviewCount: 35000,
    occasionValue: 'valentines',
  },
  {
    id: 'lush-bath-bombs',
    name: 'Lush Bath Bomb Gift Set',
    asin: 'B07N4B2KPB',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07N4B2KPB._SL300_.jpg',
    price: 35.0,
    brand: 'Lush',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'olaplex-no-3',
    name: 'Olaplex No. 3',
    asin: 'B00SNM5US4',
    amznLink: 'https://amzn.to/4rTfO83',
    image: 'https://m.media-amazon.com/images/P/B00SNM5US4._SL300_.jpg',
    price: 0,
    brand: 'Olaplex',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'philips-norelco-9800',
    name: 'Philips Norelco 9800',
    asin: 'B0BVRQC6R4',
    amznLink: 'https://amzn.to/4kQ6zDl',
    image: 'https://m.media-amazon.com/images/P/B0BVRQC6R4._SL300_.jpg',
    price: 0,
    brand: 'Philips',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'boyfriend', 'christmas', 'fathersday', 'girlfriend', 'her', 'him', 'mothersday', 'valentines'],
  },
  {
    id: 'revlon-one-step',
    name: 'Revlon One-Step',
    asin: 'B0971TRSC2',
    amznLink: 'https://amzn.to/3Mrlm9N',
    image: 'https://m.media-amazon.com/images/P/B0971TRSC2._SL300_.jpg',
    price: 0,
    brand: 'Revlon',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 69.99,
    salePrice: 40.0,
    discountPercent: 43,
    rating: 4.6,
    reviewCount: 320000,
    occasionValue: 'valentines',
  },
  {
    id: 'slip-pillowcase',
    name: 'Slip Silk Pillowcase',
    asin: 'B078P5F988',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B078P5F988._SL300_.jpg',
    price: 85.0,
    brand: 'Slip',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'sol-de-janeiro-brazilian-bum-bum-cream',
    name: 'Sol de Janeiro Brazilian Bum Bum Cream',
    asin: null,
    amznLink: 'https://amzn.to/4c4ESUP',
    image: 'https://m.media-amazon.com/images/I/71acAwNd40L._SL500_.jpg',
    price: 48.0,
    brand: 'Sol de Janeiro',
    category: 'beauty',
    description: 'A cult-favorite body cream that helps visibly tighten and smooth the skin while smelling incredible.',
    tags: ['beauty', 'birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    rating: 4.7,
    reviewCount: 45000,
  },
  {
    id: 'tatcha-dewy-skin-cream',
    name: 'Tatcha Dewy Skin Cream',
    asin: 'B09QBB8ZL4',
    amznLink: 'https://amzn.to/4rfE1FI',
    image: 'https://m.media-amazon.com/images/P/B09QBB8ZL4._SL300_.jpg',
    price: 0,
    brand: 'Tatcha',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'tatcha-set',
    name: 'Tatcha Dewy Skin Set',
    asin: 'B0BNM2W4DF',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BNM2W4DF._SL300_.jpg',
    price: 68.0,
    brand: 'Tatcha',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'therabody-theraface-pro',
    name: 'Therabody TheraFace Pro',
    asin: 'B0FVY6P61B',
    amznLink: 'https://amzn.to/4tF2zcV',
    image: 'https://m.media-amazon.com/images/I/61lWktPiaIL._SL300_.jpg',
    price: 0,
    brand: 'Therabody',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'tom-ford-oud',
    name: 'Tom Ford Oud Wood',
    asin: 'B00FZ7E7RK',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00FZ7E7RK._SL300_.jpg',
    price: 195.0,
    brand: 'Tom Ford',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'versace-eros',
    name: 'Versace Eros Eau de Toilette',
    asin: 'B00G0U1PR6',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00G0U1PR6._SL300_.jpg',
    price: 65.0,
    brand: 'Versace',
    category: 'beauty',
    description: '',
    tags: ['beauty', 'birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },

  // === FASHION ===
  {
    id: 'anne-klein-bangle-watch-and-bracelet-set',
    name: 'Anne Klein Bangle Watch and Bracelet Set',
    asin: null,
    amznLink: 'https://amzn.to/4qgDVfU',
    image: 'https://m.media-amazon.com/images/I/81x8mjmCZrL._AC_SX679_.jpg',
    price: 65.0,
    brand: 'Anne Klein',
    category: 'fashion',
    description: 'A sophisticated gift set featuring a gold-tone watch and three matching decorative bracelets.',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 150.0,
    salePrice: 65.0,
    discountPercent: 57,
    rating: 4.6,
    reviewCount: 18000,
    occasionValue: 'valentines',
  },
  {
    id: 'away-bigger-carry-on',
    name: 'Away Bigger Carry-On',
    asin: 'B0DLJF5V75',
    amznLink: 'https://amzn.to/4kH6OQX',
    image: 'https://m.media-amazon.com/images/P/B0DLJF5V75._SL300_.jpg',
    price: 0,
    brand: 'Away',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'christmas', 'fashion', 'her', 'him', 'teen'],
  },
  {
    id: 'away-carry-on',
    name: 'Away Carry-On',
    asin: 'B0DLJHS52R',
    amznLink: 'https://amzn.to/3ZIoi5V',
    image: 'https://m.media-amazon.com/images/P/B0DLJHS52R._SL300_.jpg',
    price: 0,
    brand: 'Away',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'christmas', 'fashion', 'her', 'him', 'teen'],
  },
  {
    id: 'robe-womens',
    name: 'Barefoot Dreams CozyChic Robe',
    asin: 'B07BFQVRZS',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07BFQVRZS._SL300_.jpg',
    price: 99.0,
    brand: 'Barefoot Dreams',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'bellroy-wallet',
    name: 'Bellroy Slim Sleeve Wallet',
    asin: 'B00GTUITB2',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00GTUITB2._SL300_.jpg',
    price: 79.0,
    brand: 'Bellroy',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'her', 'him'],
  },
  {
    id: 'citizen-eco-drive',
    name: 'Citizen Eco-Drive Watch',
    asin: 'B07MQWCNHB',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07MQWCNHB._SL300_.jpg',
    price: 175.0,
    brand: 'Citizen',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-100-200', 'christmas', 'fashion', 'girlfriend', 'her', 'him'],
  },
  {
    id: 'coach-bag',
    name: 'Coach Gallery Tote',
    asin: 'B07YZ6W6F5',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07YZ6W6F5._SL300_.jpg',
    price: 195.0,
    brand: 'Coach',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'fossil-watch',
    name: 'Fossil Grant Chronograph Watch',
    asin: 'B008AXUQ4O',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B008AXUQ4O._SL300_.jpg',
    price: 99.0,
    brand: 'Fossil',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'him'],
  },
  {
    id: 'herschel-novel-duffle',
    name: 'Herschel Novel Duffle',
    asin: 'B0C3B2TP3T',
    amznLink: 'https://amzn.to/4tHBw0y',
    image: 'https://m.media-amazon.com/images/P/B0C3B2TP3T._SL300_.jpg',
    price: 0,
    brand: 'Herschel',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'teen', 'valentines'],
  },
  {
    id: 'kate-spade-bag',
    name: 'Kate Spade Medium Satchel',
    asin: 'B089S94VQX',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B089S94VQX._SL300_.jpg',
    price: 179.0,
    brand: 'Kate Spade',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'michael-kors-bag',
    name: 'Michael Kors Jet Set Tote',
    asin: 'B08LHBPN42',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B08LHBPN42._SL300_.jpg',
    price: 139.0,
    brand: 'Michael Kors',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'oakley-holbrook',
    name: 'Oakley Holbrook Sunglasses',
    asin: 'B06XW16QMS',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B06XW16QMS._SL300_.jpg',
    price: 141.0,
    brand: 'Oakley',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'fashion', 'her', 'him'],
  },
  {
    id: 'pavoi-14k-gold-plated-hoop-earrings',
    name: 'PAVOI 14K Gold Plated Hoop Earrings',
    asin: null,
    amznLink: 'https://amzn.to/4qULR7q',
    image: 'https://m.media-amazon.com/images/I/61qx4tKiRlL._AC_SY695_.jpg',
    price: 13.0,
    brand: 'PAVOI',
    category: 'fashion',
    description: 'Elegant, lightweight gold hoops that are perfect for daily wear. Lead and nickel-free for sensitive ears.',
    tags: ['birthday', 'budget-under25', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'teen', 'valentines'],
    originalPrice: 15.95,
    salePrice: 13.0,
    discountPercent: 18,
    rating: 4.5,
    reviewCount: 52000,
    occasionValue: 'valentines',
  },
  {
    id: 'cashmere-scarf',
    name: 'Pure Cashmere Scarf',
    asin: 'B00G7OP6U2',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00G7OP6U2._SL300_.jpg',
    price: 79.0,
    brand: 'Pure',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'her', 'him'],
  },
  {
    id: 'rayban-aviator',
    name: 'Ray-Ban Aviator Classic',
    asin: 'B0814DWCZL',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0814DWCZL._SL300_.jpg',
    price: 154.0,
    brand: 'Ray-Ban',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'fashion', 'her', 'him'],
  },
  {
    id: 'ray-ban-meta-wayfarer',
    name: 'Ray-Ban Meta Wayfarer',
    asin: 'B0FLYL6DBL',
    amznLink: 'https://amzn.to/4roiV8g',
    image: 'https://m.media-amazon.com/images/P/B0FLYL6DBL._SL300_.jpg',
    price: 0,
    brand: 'Ray-Ban',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'christmas', 'fashion', 'her', 'him', 'teen'],
  },
  {
    id: 'seiko-presage',
    name: 'Seiko Presage Automatic Watch',
    asin: 'B084YVRDQV',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B084YVRDQV._SL300_.jpg',
    price: 295.0,
    brand: 'Seiko',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-200plus', 'christmas', 'fashion', 'girlfriend', 'her', 'him'],
  },
  {
    id: 'swarovski-infinity-knot-necklace',
    name: 'Swarovski Infinity Knot Necklace',
    asin: null,
    amznLink: 'https://amzn.to/46ftwK0',
    image: 'https://m.media-amazon.com/images/I/61d+hCoWQVL._AC_SY695_.jpg',
    price: 92.0,
    brand: 'Swarovski',
    category: 'fashion',
    description: 'A stunning rose-gold tone plated necklace featuring a white crystal-embellished infinity symbol.',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 115.0,
    salePrice: 92.0,
    discountPercent: 20,
    rating: 4.6,
    reviewCount: 3000,
    occasionValue: 'valentines',
  },
  {
    id: 'blue-light-glasses',
    name: 'TIJN Blue Light Blocking Glasses',
    asin: 'B082HXS2VL',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B082HXS2VL._SL300_.jpg',
    price: 15.0,
    brand: 'TIJN',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'fashion', 'her', 'him', 'teen'],
  },
  {
    id: 'ridge-wallet',
    name: 'The Ridge Wallet',
    asin: 'B0CNS7GR22',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CNS7GR22._SL300_.jpg',
    price: 95.0,
    brand: 'Ridge',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'her', 'him'],
  },
  {
    id: 'leather-belt',
    name: 'Tommy Hilfiger Leather Belt',
    asin: 'B00HR0YDMC',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00HR0YDMC._SL300_.jpg',
    price: 29.0,
    brand: 'Tommy Hilfiger',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'fashion', 'fathersday', 'girlfriend', 'her', 'him', 'mothersday', 'teen', 'valentines'],
  },
  {
    id: 'slippers-mens',
    name: 'UGG Ascot Slippers',
    asin: 'B000F5FO64',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B000F5FO64._SL300_.jpg',
    price: 99.0,
    brand: 'Slip',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'slippers-womens',
    name: 'UGG Fluff Yeah Slippers',
    asin: 'B08JDS5Y1X',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B08JDS5Y1X._SL300_.jpg',
    price: 99.0,
    brand: 'Slip',
    category: 'fashion',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },

  // === GAMING ===
  {
    id: 'logitech-keyboard',
    name: 'Logitech G Pro Mechanical Keyboard',
    asin: 'B07QQB9VCV',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07QQB9VCV._SL300_.jpg',
    price: 99.0,
    brand: 'Logitech',
    category: 'gaming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'dad', 'fathersday', 'gaming', 'him', 'teen'],
  },
  {
    id: 'ps5-controller',
    name: 'PlayStation 5 DualSense Controller',
    asin: 'B0CQKLS4RP',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CQKLS4RP._SL300_.jpg',
    price: 69.0,
    brand: 'PlayStation',
    category: 'gaming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'dad', 'fathersday', 'gaming', 'him', 'teen'],
  },
  {
    id: 'razer-headset',
    name: 'Razer BlackShark V2 Gaming Headset',
    asin: 'B086PKMZ1Q',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B086PKMZ1Q._SL300_.jpg',
    price: 79.0,
    brand: 'Razer',
    category: 'gaming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'dad', 'fathersday', 'gaming', 'him', 'teen'],
  },
  {
    id: 'xbox-controller',
    name: 'Xbox Wireless Controller',
    asin: 'B0BY3ZLHV3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BY3ZLHV3._SL300_.jpg',
    price: 49.0,
    brand: 'Xbox',
    category: 'gaming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'dad', 'fathersday', 'gaming', 'him', 'teen'],
  },

  // === GROOMING ===
  {
    id: 'baxter-of-california-face-wash',
    name: 'Baxter of California Face Wash',
    asin: 'B000HP7INK',
    amznLink: 'https://amzn.to/4cyiKm0',
    image: 'https://m.media-amazon.com/images/P/B000HP7INK._SL300_.jpg',
    price: 0,
    brand: 'Baxter',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'dad', 'fathersday', 'grooming', 'him'],
  },
  {
    id: 'beardbrand-utility-balm',
    name: 'Beardbrand Utility Balm',
    asin: 'B0D2ZD32C1',
    amznLink: 'https://amzn.to/3OsRwmT',
    image: 'https://m.media-amazon.com/images/P/B0D2ZD32C1._SL300_.jpg',
    price: 0,
    brand: 'Beardbrand',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'dad', 'fathersday', 'grooming', 'him'],
  },
  {
    id: 'manscaped-5-0',
    name: 'Manscaped 5.0',
    asin: 'B0CSM6N46F',
    amznLink: 'https://amzn.to/4kFh8sN',
    image: 'https://m.media-amazon.com/images/P/B0CSM6N46F._SL300_.jpg',
    price: 0,
    brand: 'Manscaped',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'dad', 'fathersday', 'grooming', 'him'],
  },
  {
    id: 'philips-trimmer',
    name: 'Philips Norelco Multigroom',
    asin: 'B07T5YFFL6',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07T5YFFL6._SL300_.jpg',
    price: 24.0,
    brand: 'Philips',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-under25', 'christmas', 'fathersday', 'girlfriend', 'grooming', 'her', 'him', 'mothersday', 'valentines'],
  },
  {
    id: 'skincare-men',
    name: 'Tiege Hanley Skincare Set for Men',
    asin: 'B0B6G8VL9N',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0B6G8VL9N._SL300_.jpg',
    price: 35.0,
    brand: 'Tiege Hanley',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'fathersday', 'girlfriend', 'grooming', 'her', 'him', 'mothersday', 'valentines'],
  },
  {
    id: 'beard-kit',
    name: 'Viking Revolution Beard Care Kit',
    asin: 'B07B53Q3BX',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07B53Q3BX._SL300_.jpg',
    price: 23.0,
    brand: 'Viking',
    category: 'grooming',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-under25', 'christmas', 'dad', 'fathersday', 'grooming', 'him'],
  },

  // === HOME ===
  {
    id: 'bathtub-tray',
    name: 'Bamboo Bathtub Caddy Tray',
    asin: 'B07MH4Z7QZ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07MH4Z7QZ._SL300_.jpg',
    price: 29.0,
    brand: 'Bamboo',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'bath-body-candle',
    name: 'Bath & Body Works 3-Wick Candle',
    asin: 'B0BGFXHCMV',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BGFXHCMV._SL300_.jpg',
    price: 24.0,
    brand: 'Bath & Body Works',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'cozy-blanket',
    name: 'Bedsure Fleece Throw Blanket',
    asin: 'B01LZXE20U',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01LZXE20U._SL300_.jpg',
    price: 19.0,
    brand: 'Bedsure',
    category: 'home',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-under25', 'christmas', 'girlfriend', 'her', 'him', 'home'],
  },
  {
    id: 'breville-barista-express',
    name: 'Breville Barista Express',
    asin: 'B00CH9QWOU',
    amznLink: 'https://amzn.to/4qD744P',
    image: 'https://m.media-amazon.com/images/P/B00CH9QWOU._SL300_.jpg',
    price: 0,
    brand: 'Breville',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'planner',
    name: 'Clever Fox Planner Pro',
    asin: 'B0BQXKQPCJ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BQXKQPCJ._SL300_.jpg',
    price: 29.0,
    brand: 'Clever Fox',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'tool-set',
    name: 'DEWALT Mechanics Tool Set',
    asin: 'B00KHYLM2Y',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00KHYLM2Y._SL300_.jpg',
    price: 89.0,
    brand: 'DEWALT',
    category: 'home',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'dad', 'fathersday', 'him', 'home'],
  },
  {
    id: 'dash-mini-heart-waffle-maker',
    name: 'Dash Mini Heart Waffle Maker',
    asin: null,
    amznLink: 'https://amzn.to/4kbfWgu',
    image: 'https://m.media-amazon.com/images/I/81yD3mJBFhL._AC_SL500_.jpg',
    price: 14.99,
    brand: 'Dash',
    category: 'home',
    description: 'Make breakfast romantic with heart-shaped waffles. Compact, non-stick, and perfect for quick, cute meals.',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'home'],
    originalPrice: 19.99,
    salePrice: 14.99,
    discountPercent: 25,
    rating: 4.8,
    reviewCount: 225000,
    occasionValue: 'valentines',
  },
  {
    id: 'ember-mug-2',
    name: 'Ember Mug 2',
    asin: 'B07NQRM6ML',
    amznLink: 'https://amzn.to/46eqG8h',
    image: 'https://m.media-amazon.com/images/I/51tXJGC0gQL._SL300_.jpg',
    price: 0,
    brand: 'Ember',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'meal-prep-containers',
    name: 'Glass Meal Prep Containers Set',
    asin: 'B07FLT8PTM',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07FLT8PTM._SL300_.jpg',
    price: 29.0,
    brand: 'Glass',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'homesick-scented-candle-love-letters',
    name: 'Homesick Scented Candle, Love Letters',
    asin: null,
    amznLink: 'https://amzn.to/4keOwX1',
    image: 'https://m.media-amazon.com/images/I/71VMXcyUEaL._AC_SL500_.jpg',
    price: 34.0,
    brand: 'Homesick',
    category: 'home',
    description: 'Top notes of rose petals and jasmine. A thoughtful, high-quality soy wax candle for a romantic atmosphere.',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
    originalPrice: 38.0,
    salePrice: 34.0,
    discountPercent: 11,
    rating: 4.6,
    reviewCount: 14000,
    occasionValue: 'valentines',
  },
  {
    id: 'instant-pot-pro',
    name: 'Instant Pot Pro',
    asin: 'B08PQ2KWHS',
    amznLink: 'https://amzn.to/4c07oao',
    image: 'https://m.media-amazon.com/images/P/B08PQ2KWHS._SL300_.jpg',
    price: 0,
    brand: 'Instant Pot',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'keurig-machine',
    name: 'Keurig K-Elite Coffee Maker',
    asin: 'B078NN17K3',
    amznLink: 'https://amzn.to/4aRr1QR',
    image: 'https://m.media-amazon.com/images/I/71eood2xIWL._SL300_.jpg',
    price: 139.0,
    brand: 'Keurig',
    category: 'home',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'him', 'home'],
  },
  {
    id: 'keurig-k-mini-single-serve-coffee-maker',
    name: 'Keurig K-Mini Single Serve Coffee Maker',
    asin: null,
    amznLink: 'https://amzn.to/46fau6y',
    image: 'https://m.media-amazon.com/images/I/618D34n8gLL._AC_SL500_.jpg',
    price: 59.0,
    brand: 'Keurig',
    category: 'home',
    description: 'Under 5 inches wide, perfect for small spaces. Brews any cup size between 6-12oz with Keurig K-Cup pods.',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'him', 'home'],
    originalPrice: 99.99,
    salePrice: 59.0,
    discountPercent: 41,
    rating: 4.5,
    reviewCount: 102000,
    occasionValue: 'valentines',
  },
  {
    id: 'kitchenaid-stand-mixer',
    name: 'KitchenAid Stand Mixer',
    asin: 'B010NCCLUQ',
    amznLink: 'https://amzn.to/3ZHh6Hf',
    image: 'https://m.media-amazon.com/images/P/B010NCCLUQ._SL300_.jpg',
    price: 0,
    brand: 'KitchenAid',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'le-creuset-dutch-oven',
    name: 'Le Creuset Dutch Oven',
    asin: 'B00VWMFLQI',
    amznLink: 'https://amzn.to/3Mg9CYR',
    image: 'https://m.media-amazon.com/images/P/B00VWMFLQI._SL300_.jpg',
    price: 0,
    brand: 'Le Creuset',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'levoit-core-300-air-purifier',
    name: 'Levoit Core 300 Air Purifier',
    asin: null,
    amznLink: 'https://amzn.to/4kbgmDA',
    image: 'https://m.media-amazon.com/images/I/61e1XQ2rETL._AC_SL500_.jpg',
    price: 84.0,
    brand: 'Levoit',
    category: 'home',
    description: 'The #1 air purifier for homes. Refresh the air in minutes with high-efficiency H13 True HEPA filtration.',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'home'],
    originalPrice: 99.99,
    salePrice: 84.0,
    discountPercent: 16,
    rating: 4.7,
    reviewCount: 118000,
    occasionValue: 'valentines',
  },
  {
    id: 'lodge-cast-iron-skillet',
    name: 'Lodge Cast Iron Skillet',
    asin: 'B00006JSUA',
    amznLink: 'https://amzn.to/4aHFFsL',
    image: 'https://m.media-amazon.com/images/P/B00006JSUA._SL300_.jpg',
    price: 0,
    brand: 'Lodge',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'journal',
    name: 'Moleskine Classic Notebook',
    asin: 'B015NG44DQ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B015NG44DQ._SL300_.jpg',
    price: 19.0,
    brand: 'Moleskine',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'nespresso-machine',
    name: 'Nespresso Vertuo Plus',
    asin: 'B01N7GO468',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01N7GO468._SL300_.jpg',
    price: 159.0,
    brand: 'Nespresso',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'nespresso-vertuo-pop',
    name: 'Nespresso Vertuo Pop+',
    asin: 'B0DVCZB8VS',
    amznLink: 'https://amzn.to/4rnym0g',
    image: 'https://m.media-amazon.com/images/P/B0DVCZB8VS._SL300_.jpg',
    price: 0,
    brand: 'Nespresso',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'ninja-air-fryer',
    name: 'Ninja Air Fryer',
    asin: 'B089TQWJKK',
    amznLink: 'https://amzn.to/4roXO5R',
    image: 'https://m.media-amazon.com/images/I/511+uXaPLlL._SL300_.jpg',
    price: 0,
    brand: 'Ninja',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'blender-personal',
    name: 'Ninja Personal Blender',
    asin: 'B0BGPZN4WD',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BGPZN4WD._SL300_.jpg',
    price: 49.0,
    brand: 'Ninja',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'photo-album',
    name: 'Premium Leather Photo Album',
    asin: 'B0797R4VKL',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0797R4VKL._SL300_.jpg',
    price: 29.0,
    brand: 'Premium',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'flowers-preserved',
    name: 'Preserved Rose in Glass Dome',
    asin: 'B07Q34Q2WQ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07Q34Q2WQ._SL300_.jpg',
    price: 25.0,
    brand: 'Preserved',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'cocktail-set',
    name: 'Professional Bartender Kit',
    asin: 'B07B9KLRDC',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07B9KLRDC._SL300_.jpg',
    price: 29.0,
    brand: 'Professional',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'rocketbook-core',
    name: 'Rocketbook Core',
    asin: 'B0DP3J346V',
    amznLink: 'https://amzn.to/4rZ47gk',
    image: 'https://m.media-amazon.com/images/P/B0DP3J346V._SL300_.jpg',
    price: 0,
    brand: 'Rocketbook',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'jewelry-box',
    name: 'SONGMICS Jewelry Box Organizer',
    asin: 'B07GBFMPRW',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07GBFMPRW._SL300_.jpg',
    price: 25.0,
    brand: 'SONGMICS',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'desk-organizer',
    name: 'SimpleHouseware Desk Organizer',
    asin: 'B0756CLNZ3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0756CLNZ3._SL300_.jpg',
    price: 15.0,
    brand: 'SimpleHouseware',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'blanket-heated',
    name: 'Sunbeam Heated Throw Blanket',
    asin: 'B00EA0DLNG',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00EA0DLNG._SL300_.jpg',
    price: 49.0,
    brand: 'Sunbeam',
    category: 'home',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'him', 'home'],
  },
  {
    id: 'essential-oil-diffuser',
    name: 'VITRUVI Stone Diffuser',
    asin: 'B01N9QOPVS',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01N9QOPVS._SL300_.jpg',
    price: 99.0,
    brand: 'VITRUVI',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'vitamix-5200',
    name: 'Vitamix 5200',
    asin: 'B008H4SLV6',
    amznLink: 'https://amzn.to/4qD7nfZ',
    image: 'https://m.media-amazon.com/images/I/71LFQWt5nEL._SL300_.jpg',
    price: 0,
    brand: 'Vitamix',
    category: 'home',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'home'],
  },
  {
    id: 'voluspa-candle',
    name: 'Voluspa Japonica Candle',
    asin: 'B00GFBPLXS',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00GFBPLXS._SL300_.jpg',
    price: 32.0,
    brand: 'Voluspa',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'whiskey-stones',
    name: 'Whiskey Stones Gift Set',
    asin: 'B07M7MRWVZ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07M7MRWVZ._SL300_.jpg',
    price: 19.0,
    brand: 'Whiskey',
    category: 'home',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-under25', 'christmas', 'dad', 'fathersday', 'him', 'home'],
  },
  {
    id: 'yankee-candle-set',
    name: 'Yankee Candle Gift Set',
    asin: 'B09MQ9KQJ6',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B09MQ9KQJ6._SL300_.jpg',
    price: 29.0,
    brand: 'Yankee Candle',
    category: 'home',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'home', 'mom', 'mothersday', 'valentines'],
  },

  // === JEWELRY ===
  {
    id: 'kate-spade-earrings',
    name: 'Kate Spade Stud Earrings',
    asin: 'B00979OX6W',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00979OX6W._SL300_.jpg',
    price: 38.0,
    brand: 'Kate Spade',
    category: 'jewelry',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'pandora-bracelet',
    name: 'Pandora Moments Charm Bracelet',
    asin: 'B00S18EKAE',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00S18EKAE._SL300_.jpg',
    price: 65.0,
    brand: 'Pandora',
    category: 'jewelry',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'fashion', 'fathersday', 'girlfriend', 'her', 'him', 'mothersday', 'valentines'],
  },
  {
    id: 'initial-necklace',
    name: 'Personalized Initial Necklace',
    asin: 'B07TQWXJZ3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07TQWXJZ3._SL300_.jpg',
    price: 16.0,
    brand: 'Personalized',
    category: 'jewelry',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'heart-earrings',
    name: 'Sterling Silver Heart Stud Earrings',
    asin: 'B07XQ8FQGK',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07XQ8FQGK._SL300_.jpg',
    price: 15.0,
    brand: 'Sterling',
    category: 'jewelry',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'swarovski-necklace',
    name: 'Swarovski Crystal Pendant Necklace',
    asin: 'B09BBCC682',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B09BBCC682._SL300_.jpg',
    price: 79.0,
    brand: 'Swarovski',
    category: 'jewelry',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'fashion', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },

  // === OTHER ===
  {
    id: 'bath-body-works-gift-set',
    name: 'Bath & Body Works Gift Set',
    asin: 'B08Y99M4PC',
    amznLink: 'https://amzn.to/4tFeyqH',
    image: 'https://m.media-amazon.com/images/P/B08Y99M4PC._SL300_.jpg',
    price: 0,
    brand: 'Bath & Body Works',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'bose-quietcomfort',
    name: 'Bose QuietComfort',
    asin: 'B0CCZ26B5V',
    amznLink: 'https://amzn.to/3ZJB9Vx',
    image: 'https://m.media-amazon.com/images/P/B0CCZ26B5V._SL300_.jpg',
    price: 0,
    brand: 'Bose',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'fitbit-charge-6',
    name: 'Fitbit Charge 6',
    asin: 'B0CM863HWF',
    amznLink: 'https://amzn.to/4qHEMq2',
    image: 'https://m.media-amazon.com/images/P/B0CM863HWF._SL300_.jpg',
    price: 0,
    brand: 'Fitbit',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'fitbit-inspire-3',
    name: 'Fitbit Inspire 3',
    asin: 'B0BWPV5ZWW',
    amznLink: 'https://amzn.to/4czXe0h',
    image: 'https://m.media-amazon.com/images/P/B0BWPV5ZWW._SL300_.jpg',
    price: 0,
    brand: 'Fitbit',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'fujifilm-instax-mini-12',
    name: 'Fujifilm Instax Mini 12',
    asin: 'B0BWNZCL1T',
    amznLink: 'https://amzn.to/40czCYb',
    image: 'https://m.media-amazon.com/images/I/51iPhTbF0pL._SL300_.jpg',
    price: 0,
    brand: 'Fujifilm',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 79.95,
    salePrice: 69.95,
    discountPercent: 13,
    rating: 4.8,
    reviewCount: 15000,
    occasionValue: 'valentines',
  },
  {
    id: 'fujifilm-instax-mini-evo',
    name: 'Fujifilm Instax Mini Evo',
    asin: 'B0DN2T984S',
    amznLink: 'https://amzn.to/40e4sQ7',
    image: 'https://m.media-amazon.com/images/I/811QR1lqlnL._SL300_.jpg',
    price: 0,
    brand: 'Fujifilm',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'jbl-go-3',
    name: 'JBL Go 3',
    asin: 'B0D5N5PZKD',
    amznLink: 'https://amzn.to/4bZPLYm',
    image: 'https://m.media-amazon.com/images/I/61TgmOFiZ4L._SL300_.jpg',
    price: 0,
    brand: 'JBL',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'luna-bean-hand-casting-kit',
    name: 'Luna Bean Hand Casting Kit',
    asin: null,
    amznLink: 'https://amzn.to/4kgtOWP',
    image: 'https://m.media-amazon.com/images/I/81dkBxdlmOL._AC_SL500_.jpg',
    price: 39.0,
    brand: 'Luna Bean',
    category: 'other',
    description: 'Unique DIY gift for couples. Create a highly detailed plaster statue of your hands held together.',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
    originalPrice: 49.99,
    salePrice: 39.0,
    discountPercent: 22,
    rating: 4.6,
    reviewCount: 34000,
    occasionValue: 'valentines',
  },
  {
    id: 'polaroid-now',
    name: 'Polaroid Now+',
    asin: 'B0BVN4LLMQ',
    amznLink: 'https://amzn.to/4rPOszG',
    image: 'https://m.media-amazon.com/images/P/B0BVN4LLMQ._SL300_.jpg',
    price: 0,
    brand: 'Polaroid',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'sony-wh-1000xm5',
    name: 'Sony WH-1000XM5',
    asin: 'B0BXYCS74H',
    amznLink: 'https://amzn.to/4bTGnoZ',
    image: 'https://m.media-amazon.com/images/I/61oUbsHuWuL._SL300_.jpg',
    price: 0,
    brand: 'Sony',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'soundcore-life-q30',
    name: 'Soundcore Life Q30',
    asin: 'B08HMWZBXC',
    amznLink: 'https://amzn.to/4bZOD74',
    image: 'https://m.media-amazon.com/images/P/B08HMWZBXC._SL300_.jpg',
    price: 0,
    brand: 'Soundcore',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'ti-84-plus-ce',
    name: 'TI-84 Plus CE',
    asin: 'B07FK8SQDQ',
    amznLink: 'https://amzn.to/4rOyLsu',
    image: 'https://m.media-amazon.com/images/P/B07FK8SQDQ._SL300_.jpg',
    price: 0,
    brand: 'TI-84',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'tile-essentials-4-pack',
    name: 'Tile Essentials 4-Pack',
    asin: 'B0D6354JRF',
    amznLink: 'https://amzn.to/3OvGyNr',
    image: 'https://m.media-amazon.com/images/I/71+aVLr7STL._SL300_.jpg',
    price: 0,
    brand: 'Tile',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },
  {
    id: 'tile-mate',
    name: 'Tile Mate',
    asin: 'B09RG31GKT',
    amznLink: 'https://amzn.to/4axCxPV',
    image: 'https://m.media-amazon.com/images/P/B09RG31GKT._SL300_.jpg',
    price: 0,
    brand: 'Tile',
    category: 'other',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'valentines'],
  },

  // === OUTDOOR ===
  {
    id: 'grilling-set',
    name: 'BBQ Grill Tools Set',
    asin: 'B00NE5IF3W',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00NE5IF3W._SL300_.jpg',
    price: 35.0,
    brand: 'BBQ',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'dad', 'fathersday', 'him', 'travel'],
  },
  {
    id: 'contigo-west-loop',
    name: 'Contigo West Loop',
    asin: 'B0CYTL611N',
    amznLink: 'https://amzn.to/4aA6Zcf',
    image: 'https://m.media-amazon.com/images/P/B0CYTL611N._SL300_.jpg',
    price: 0,
    brand: 'Contigo',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },
  {
    id: 'herschel-backpack',
    name: 'Herschel Little America Backpack',
    asin: 'B00838TCDA',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B00838TCDA._SL300_.jpg',
    price: 89.0,
    brand: 'Herschel',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'travel', 'valentines'],
  },
  {
    id: 'hydro-flask-32oz',
    name: 'Hydro Flask 32oz',
    asin: 'B0CQKM6PXX',
    amznLink: 'https://amzn.to/3MKaVPM',
    image: 'https://m.media-amazon.com/images/P/B0CQKM6PXX._SL300_.jpg',
    price: 0,
    brand: 'Hydro Flask',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },
  {
    id: 'water-bottle',
    name: 'Hydro Flask Water Bottle 32oz',
    asin: 'B083GC98D8',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B083GC98D8._SL300_.jpg',
    price: 39.0,
    brand: 'Hydro Flask',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'him', 'travel'],
  },
  {
    id: 'backpack-college',
    name: 'JanSport Cool Student Backpack',
    asin: 'B01A6BP0LC',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01A6BP0LC._SL300_.jpg',
    price: 45.0,
    brand: 'JanSport',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'him', 'travel'],
  },
  {
    id: 'owala-freesip',
    name: 'Owala FreeSip',
    asin: 'B0FK18X6Y1',
    amznLink: 'https://amzn.to/3OlE30j',
    image: 'https://m.media-amazon.com/images/I/41T61NyYNNL._SL300_.jpg',
    price: 0,
    brand: 'Owala',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },
  {
    id: 's-well-water-bottle',
    name: 'S\'well Water Bottle',
    asin: 'B0757JZQ37',
    amznLink: 'https://amzn.to/3ZGS8YI',
    image: 'https://m.media-amazon.com/images/P/B0757JZQ37._SL300_.jpg',
    price: 0,
    brand: 'S\'well',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'girlfriend', 'her', 'him', 'travel'],
  },
  {
    id: 'stanley-quencher-40oz',
    name: 'Stanley Quencher 40oz',
    asin: 'B0CP9Z56SW',
    amznLink: 'https://amzn.to/3OmT0z9',
    image: 'https://m.media-amazon.com/images/I/41ryNvEnNCL._SL300_.jpg',
    price: 0,
    brand: 'Stanley',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'travel', 'valentines'],
  },
  {
    id: 'stanley-quencher-h2-0-flowstate-tumbler',
    name: 'Stanley Quencher H2.0 FlowState Tumbler',
    asin: null,
    amznLink: 'https://amzn.to/3O2QrSy',
    image: 'https://m.media-amazon.com/images/I/51Isr2SIKgL._AC_SL500_.jpg',
    price: 45.0,
    brand: 'Stanley',
    category: 'outdoor',
    description: 'The most popular 40oz tumbler. Vacuum insulated to keep drinks cold for 11 hours.',
    tags: ['birthday', 'budget-25-50', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'travel', 'valentines'],
    rating: 4.8,
    reviewCount: 32000,
  },
  {
    id: 'north-face-backpack',
    name: 'The North Face Borealis Backpack',
    asin: 'B0CN9SD8JF',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CN9SD8JF._SL300_.jpg',
    price: 89.0,
    brand: 'The North Face',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'him', 'travel'],
  },
  {
    id: 'yeti-cooler',
    name: 'YETI Hopper Flip Cooler',
    asin: 'B07PB4HJLZ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07PB4HJLZ._SL300_.jpg',
    price: 199.0,
    brand: 'YETI',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'travel', 'valentines'],
  },
  {
    id: 'yeti-rambler-20oz',
    name: 'Yeti Rambler 20oz',
    asin: 'B0CV4MCX2W',
    amznLink: 'https://amzn.to/4rXTg69',
    image: 'https://m.media-amazon.com/images/I/51AVuybDJhL._SL300_.jpg',
    price: 0,
    brand: 'YETI',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },
  {
    id: 'yeti-rambler-26oz',
    name: 'Yeti Rambler 26oz',
    asin: 'B0842S56G8',
    amznLink: 'https://amzn.to/4bYYF8r',
    image: 'https://m.media-amazon.com/images/I/61wCsVnZSzL._SL300_.jpg',
    price: 0,
    brand: 'YETI',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },
  {
    id: 'yeti-rambler-30oz',
    name: 'Yeti Rambler 30oz',
    asin: 'B0CZZ1FY8M',
    amznLink: 'https://amzn.to/40126nX',
    image: 'https://m.media-amazon.com/images/P/B0CZZ1FY8M._SL300_.jpg',
    price: 0,
    brand: 'YETI',
    category: 'outdoor',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'travel'],
  },

  // === SPORTS ===
  {
    id: 'bala-bangles',
    name: 'Bala Bangles',
    asin: 'B0CF2D1YX1',
    amznLink: 'https://amzn.to/3MiYfPP',
    image: 'https://m.media-amazon.com/images/I/61yHjkXkINL._SL300_.jpg',
    price: 0,
    brand: 'Bala',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'bowflex-selecttech-552',
    name: 'Bowflex SelectTech 552',
    asin: 'B07X64MXBS',
    amznLink: 'https://amzn.to/4aA1aeW',
    image: 'https://m.media-amazon.com/images/I/61GhgyYpcRL._SL300_.jpg',
    price: 0,
    brand: 'Bowflex',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'resistance-bands',
    name: 'Fit Simplify Resistance Bands Set',
    asin: 'B01AVDVHTI',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01AVDVHTI._SL300_.jpg',
    price: 9.0,
    brand: 'Fit',
    category: 'sports',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'gaiam-premium-yoga-mat',
    name: 'Gaiam Premium Yoga Mat',
    asin: 'B077V135W7',
    amznLink: 'https://amzn.to/3MBcwYa',
    image: 'https://m.media-amazon.com/images/P/B077V135W7._SL300_.jpg',
    price: 0,
    brand: 'Gaiam',
    category: 'sports',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'girlfriend', 'her', 'him', 'sports'],
  },
  {
    id: 'golf-accessories',
    name: 'Golf Accessories Gift Set',
    asin: 'B07VWJJ8Y3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07VWJJ8Y3._SL300_.jpg',
    price: 29.0,
    brand: 'Golf',
    category: 'sports',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'hyperice-hypervolt-2',
    name: 'Hyperice Hypervolt 2',
    asin: 'B07TWFK7JW',
    amznLink: 'https://amzn.to/4s1QJIl',
    image: 'https://m.media-amazon.com/images/I/51VQlFR4o+L._SL300_.jpg',
    price: 0,
    brand: 'Hyperice',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'yoga-mat',
    name: 'Manduka PRO Yoga Mat',
    asin: 'B07Y6FFL66',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07Y6FFL66._SL300_.jpg',
    price: 95.0,
    brand: 'Manduka',
    category: 'sports',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'him', 'sports'],
  },
  {
    id: 'manduka-pro-yoga-mat',
    name: 'Manduka PRO Yoga Mat',
    asin: 'B09WF85T8M',
    amznLink: 'https://amzn.to/4aTFqff',
    image: 'https://m.media-amazon.com/images/I/81oQh5H8mWL._SL300_.jpg',
    price: 0,
    brand: 'Manduka',
    category: 'sports',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'girlfriend', 'her', 'him', 'sports'],
  },
  {
    id: 'oura-ring-gen3',
    name: 'Oura Ring Gen3',
    asin: 'B0CSR64238',
    amznLink: 'https://amzn.to/3MiXSop',
    image: 'https://m.media-amazon.com/images/I/61gcIPGWWzL._SL300_.jpg',
    price: 0,
    brand: 'Oura',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'theragun-mini',
    name: 'Theragun Mini',
    asin: 'B0D16W8531',
    amznLink: 'https://amzn.to/4tHETVk',
    image: 'https://m.media-amazon.com/images/P/B0D16W8531._SL300_.jpg',
    price: 0,
    brand: 'Theragun',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'sports', 'valentines'],
  },
  {
    id: 'foam-roller',
    name: 'TriggerPoint GRID Foam Roller',
    asin: 'B0040EGNIU',
    amznLink: 'https://amzn.to/4tFJDuD',
    image: 'https://m.media-amazon.com/images/P/B0040EGNIU._SL300_.jpg',
    price: 34.0,
    brand: 'TriggerPoint',
    category: 'sports',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'sports'],
  },
  {
    id: 'whoop-4-0',
    name: 'Whoop 4.0',
    asin: 'B0FPMRGR8S',
    amznLink: 'https://amzn.to/4rlosw6',
    image: 'https://m.media-amazon.com/images/I/61lrbDXF5ML._SL300_.jpg',
    price: 0,
    brand: 'Whoop',
    category: 'sports',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'sports'],
  },

  // === SUBSCRIPTION ===
  {
    id: 'audible-gift',
    name: 'Audible Gift Membership',
    asin: 'B0G12XZ4GJ',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0G12XZ4GJ._SL300_.jpg',
    price: 14.95,
    brand: 'Ember',
    category: 'subscription',
    description: '',
    tags: ['birthday', 'books', 'budget-under25', 'christmas', 'her', 'him'],
  },

  // === TECH ===
  {
    id: 'echo-show',
    name: 'Amazon Echo Show 8',
    asin: 'B0BLS3Y632',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BLS3Y632._SL300_.jpg',
    price: 129.0,
    brand: 'Amazon',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'amazon-echo-show-8',
    name: 'Amazon Echo Show 8',
    asin: 'B0CDJHWHKM',
    amznLink: 'https://amzn.to/3ZGFrwU',
    image: 'https://m.media-amazon.com/images/P/B0CDJHWHKM._SL300_.jpg',
    price: 0,
    brand: 'Amazon',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'amazon-fire-tv-stick-4k',
    name: 'Amazon Fire TV Stick 4K',
    asin: 'B0CBQGLR64',
    amznLink: 'https://amzn.to/4rTzKaX',
    image: 'https://m.media-amazon.com/images/P/B0CBQGLR64._SL300_.jpg',
    price: 0,
    brand: 'Amazon',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-3-in-1-charging-station-with-magsafe',
    name: 'Anker 3-in-1 Charging Station with MagSafe',
    asin: 'B09TT8GZK9',
    amznLink: 'https://amzn.to/3MeOxxV',
    image: 'https://m.media-amazon.com/images/I/71g-3rva1+L._SL300_.jpg',
    price: 0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-313-power-bank',
    name: 'Anker 313 Power Bank',
    asin: 'B0DZHMTKJ4',
    amznLink: 'https://amzn.to/3ZGuKdH',
    image: 'https://m.media-amazon.com/images/I/516VucnwuUL._SL300_.jpg',
    price: 0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-313-wireless-charger',
    name: 'Anker 313 Wireless Charger',
    asin: 'B07THHQMHM',
    amznLink: 'https://amzn.to/3MPckod',
    image: 'https://m.media-amazon.com/images/P/B07THHQMHM._SL300_.jpg',
    price: 0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-332-usb-c-hub',
    name: 'Anker 332 USB-C Hub',
    asin: 'B0BQLLB61B',
    amznLink: 'https://amzn.to/4rOeymC',
    image: 'https://m.media-amazon.com/images/P/B0BQLLB61B._SL300_.jpg',
    price: 0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-737-power-bank',
    name: 'Anker 737 Power Bank',
    asin: 'B0DCBB2YTR',
    amznLink: 'https://amzn.to/4qHd4cX',
    image: 'https://m.media-amazon.com/images/I/71K65j4IrHL._SL300_.jpg',
    price: 0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'anker-magnetic-portable-charger',
    name: 'Anker Magnetic Portable Charger',
    asin: null,
    amznLink: 'https://amzn.to/3NQdMXK',
    image: 'https://m.media-amazon.com/images/I/61KYNMzRbXL._AC_SL500_.jpg',
    price: 39.99,
    brand: 'Anker',
    category: 'tech',
    description: '5K battery pack with a foldable stand. Snap-and-go charging for iPhone 12/13/14/15 series.',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'tech', 'teen'],
    originalPrice: 49.99,
    salePrice: 39.99,
    discountPercent: 20,
    rating: 4.6,
    reviewCount: 12000,
    occasionValue: 'valentines',
  },
  {
    id: 'portable-charger',
    name: 'Anker PowerCore 10000mAh',
    asin: 'B0D5CLSMFB',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0D5CLSMFB._SL300_.jpg',
    price: 21.0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'wireless-charger',
    name: 'Anker Wireless Charging Station',
    asin: 'B094FMWPPM',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B094FMWPPM._SL300_.jpg',
    price: 25.0,
    brand: 'Anker',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'airpods-pro',
    name: 'Apple AirPods Pro (2nd Gen)',
    asin: 'B0D1XD1ZV3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0D1XD1ZV3._SL300_.jpg',
    price: 189.0,
    brand: 'Apple',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'apple-airtag-1-pack',
    name: 'Apple AirTag (1-Pack)',
    asin: null,
    amznLink: 'https://amzn.to/46uo1ar',
    image: 'https://m.media-amazon.com/images/I/713xuNx00oS._AC_SL500_.jpg',
    price: 24.0,
    brand: 'Apple',
    category: 'tech',
    description: 'The easiest way to keep track of your stuff. Attach one to your keys or slip another in your backpack.',
    tags: ['birthday', 'budget-under25', 'christmas', 'her', 'him', 'tech', 'teen'],
    originalPrice: 29.0,
    salePrice: 24.0,
    discountPercent: 17,
    rating: 4.8,
    reviewCount: 98000,
    occasionValue: 'valentines',
  },
  {
    id: 'apple-airtag-4-pack',
    name: 'Apple AirTag 4-Pack',
    asin: 'B0DJ1P83SN',
    amznLink: 'https://amzn.to/4kOe3XC',
    image: 'https://m.media-amazon.com/images/P/B0DJ1P83SN._SL300_.jpg',
    price: 0,
    brand: 'Apple',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'apple-watch-series-10',
    name: 'Apple Watch Series 10',
    asin: 'B0DGJ5KQL7',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0DGJ5KQL7._SL300_.jpg',
    price: 399.0,
    brand: 'Apple',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-200plus', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
  },
  {
    id: 'apple-ipad-air-11',
    name: 'Apple iPad Air 11',
    asin: 'B0DZ74YQ1V',
    amznLink: 'https://amzn.to/4rmj6Rh',
    image: 'https://m.media-amazon.com/images/I/713bBMg7H8L._SL300_.jpg',
    price: 0,
    brand: 'Apple',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'belkin-3-in-1-wireless-charging-stand',
    name: 'Belkin 3-in-1 Wireless Charging Stand',
    asin: 'B0B5XYX7BP',
    amznLink: 'https://amzn.to/3ZGnZso',
    image: 'https://m.media-amazon.com/images/I/618ChHQJhoL._SL300_.jpg',
    price: 0,
    brand: 'Belkin',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'desk-lamp',
    name: 'BenQ ScreenBar Monitor Light',
    asin: 'B076VNFZJG',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B076VNFZJG._SL300_.jpg',
    price: 99.0,
    brand: 'BenQ',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'bose-soundlink',
    name: 'Bose SoundLink Flex',
    asin: 'B099TJGJ91',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B099TJGJ91._SL300_.jpg',
    price: 119.0,
    brand: 'Bose',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'fitbit-charge',
    name: 'Fitbit Charge 6',
    asin: 'B0CC62ZG1M',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CC62ZG1M._SL300_.jpg',
    price: 139.0,
    brand: 'Fitbit',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'instant-camera',
    name: 'Fujifilm Instax Mini 12 Camera',
    asin: 'B0BWNYBRNL',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0BWNYBRNL._SL300_.jpg',
    price: 69.0,
    brand: 'Fujifilm',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'garmin-venu',
    name: 'Garmin Venu 3',
    asin: 'B0CDC6H66Y',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CDC6H66Y._SL300_.jpg',
    price: 449.0,
    brand: 'Garmin',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-200plus', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'gopro-hero12-black',
    name: 'GoPro HERO12 Black',
    asin: 'B0CJ3DHDCJ',
    amznLink: 'https://amzn.to/3Od8lCr',
    image: 'https://m.media-amazon.com/images/I/71iMaU3K-mL._SL300_.jpg',
    price: 0,
    brand: 'GoPro',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'tech', 'teen', 'valentines'],
  },
  {
    id: 'google-nest-hub-max',
    name: 'Google Nest Hub Max',
    asin: 'B0FKD5SVB7',
    amznLink: 'https://amzn.to/4rOxpOq',
    image: 'https://m.media-amazon.com/images/I/71yNpHyxWdL._SL300_.jpg',
    price: 0,
    brand: 'Google',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'jbl-charge-5',
    name: 'JBL Charge 5 Portable Speaker',
    asin: 'B08X4YMTPM',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B08X4YMTPM._SL300_.jpg',
    price: 139.0,
    brand: 'JBL',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
  },
  {
    id: 'kindle-paperwhite',
    name: 'Kindle Paperwhite (16 GB)',
    asin: 'B0CFPJYX7P',
    amznLink: 'https://amzn.to/49VNL1O',
    image: 'https://m.media-amazon.com/images/P/B0CFPJYX7P._SL300_.jpg',
    price: 139.0,
    brand: 'Kindle',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
    originalPrice: 149.99,
    salePrice: 139.99,
    discountPercent: 7,
    rating: 4.7,
    reviewCount: 18000,
    occasionValue: 'valentines',
  },
  {
    id: 'meater-plus-smart-meat-thermometer',
    name: 'MEATER Plus Smart Meat Thermometer',
    asin: null,
    amznLink: 'https://amzn.to/4bt5Llh',
    image: 'https://m.media-amazon.com/images/I/71VZK7AvCSL._SL500_.jpg',
    price: 79.0,
    brand: 'MEATER',
    category: 'tech',
    description: 'Perfect for the partner who loves to cook. 100% wire-free for monitoring grill or oven cooking via app.',
    tags: ['birthday', 'budget-50-100', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'tech', 'teen', 'valentines'],
    originalPrice: 99.95,
    salePrice: 79.0,
    discountPercent: 21,
    rating: 4.5,
    reviewCount: 40000,
    occasionValue: 'valentines',
  },
  {
    id: 'meta-quest-3s',
    name: 'Meta Quest 3S',
    asin: 'B0DC7V2WF7',
    amznLink: 'https://amzn.to/4cAf8xU',
    image: 'https://m.media-amazon.com/images/P/B0DC7V2WF7._SL300_.jpg',
    price: 0,
    brand: 'Meta',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'philips-hue-starter-kit',
    name: 'Philips Hue Starter Kit',
    asin: 'B0FMGR8TGB',
    amznLink: 'https://amzn.to/4axhJbj',
    image: 'https://m.media-amazon.com/images/P/B0FMGR8TGB._SL300_.jpg',
    price: 0,
    brand: 'Philips',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'tech', 'teen', 'valentines'],
  },
  {
    id: 'philips-smartsleep-wake-up-light',
    name: 'Philips SmartSleep Wake-up Light',
    asin: 'B075S53HD9',
    amznLink: 'https://amzn.to/4bTH7ui',
    image: 'https://m.media-amazon.com/images/P/B075S53HD9._SL300_.jpg',
    price: 0,
    brand: 'Philips',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'girlfriend', 'her', 'mom', 'mothersday', 'tech', 'teen', 'valentines'],
  },
  {
    id: 'renpho-smart-scale',
    name: 'RENPHO Smart Scale',
    asin: 'B095YJW56C',
    amznLink: 'https://amzn.to/3OLeJ3M',
    image: 'https://m.media-amazon.com/images/P/B095YJW56C._SL300_.jpg',
    price: 0,
    brand: 'RENPHO',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'laptop-stand',
    name: 'Rain Design mStand Laptop Stand',
    asin: 'B000OOYECC',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B000OOYECC._SL300_.jpg',
    price: 49.0,
    brand: 'Rain',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-25-50', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'roku-streaming-stick-4k',
    name: 'Roku Streaming Stick 4K',
    asin: 'B09BKCDXZC',
    amznLink: 'https://amzn.to/4kIl2Af',
    image: 'https://m.media-amazon.com/images/P/B09BKCDXZC._SL300_.jpg',
    price: 0,
    brand: 'Roku',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'samsung-buds',
    name: 'Samsung Galaxy Buds2 Pro',
    asin: 'B0B9XXG8QX',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0B9XXG8QX._SL300_.jpg',
    price: 159.0,
    brand: 'Samsung',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'samsung-galaxy-watch',
    name: 'Samsung Galaxy Watch 6',
    asin: 'B0C792QRW6',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0C792QRW6._SL300_.jpg',
    price: 269.0,
    brand: 'Samsung',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-200plus', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
  },
  {
    id: 'skylight-calendar',
    name: 'Skylight Calendar',
    asin: 'B0C9V811L6',
    amznLink: 'https://amzn.to/4qRBdxK',
    image: 'https://m.media-amazon.com/images/P/B0C9V811L6._SL300_.jpg',
    price: 0,
    brand: 'Skylight',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'digital-photo-frame',
    name: 'Skylight Digital Photo Frame',
    asin: 'B01N7ENHO6',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B01N7ENHO6._SL300_.jpg',
    price: 159.0,
    brand: 'Skylight',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-100-200', 'christmas', 'her', 'him', 'tech'],
  },
  {
    id: 'sony-wf1000xm5',
    name: 'Sony WF-1000XM5 Wireless Earbuds',
    asin: 'B0CJ144XK3',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B0CJ144XK3._SL300_.jpg',
    price: 198.0,
    brand: 'Sony',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-100-200', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
  },
  {
    id: 'noise-cancelling-headphones',
    name: 'Sony WH-1000XM5 Headphones',
    asin: 'B09XS7JWHH',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B09XS7JWHH._SL300_.jpg',
    price: 328.0,
    brand: 'Sony',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'budget-200plus', 'christmas', 'girlfriend', 'her', 'him', 'tech'],
  },
  {
    id: 'soundcore-2-bluetooth-speaker',
    name: 'Soundcore 2 Bluetooth Speaker',
    asin: 'B0DV4JVJKD',
    amznLink: 'https://amzn.to/4rPvWHG',
    image: 'https://m.media-amazon.com/images/P/B0DV4JVJKD._SL300_.jpg',
    price: 0,
    brand: 'Soundcore',
    category: 'tech',
    description: '',
    tags: ['birthday', 'boyfriend', 'christmas', 'girlfriend', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'ue-boom-3',
    name: 'Ultimate Ears BOOM 3',
    asin: 'B07DD77VHV',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B07DD77VHV._SL300_.jpg',
    price: 99.0,
    brand: 'Ultimate',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'smart-scale',
    name: 'Withings Body+ Smart Scale',
    asin: 'B071XW4C5Q',
    amznLink: null,
    image: 'https://m.media-amazon.com/images/P/B071XW4C5Q._SL300_.jpg',
    price: 79.0,
    brand: 'Withings',
    category: 'tech',
    description: '',
    tags: ['birthday', 'budget-50-100', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'irobot-roomba-j7',
    name: 'iRobot Roomba j7+',
    asin: 'B094NYHTMF',
    amznLink: 'https://amzn.to/3MitJWi',
    image: 'https://m.media-amazon.com/images/I/71NwZ7H+zEL._SL300_.jpg',
    price: 0,
    brand: 'iRobot',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
  {
    id: 'remarkable-2',
    name: 'reMarkable 2',
    asin: 'B0DGBDR2PM',
    amznLink: 'https://amzn.to/46dnoC7',
    image: 'https://m.media-amazon.com/images/I/81hzdqvzieL._SL300_.jpg',
    price: 0,
    brand: 'reMarkable',
    category: 'tech',
    description: '',
    tags: ['birthday', 'christmas', 'her', 'him', 'tech', 'teen'],
  },
];

// ==============================
// LOOKUP MAPS
// ==============================

/** O(1) ASIN lookup */
export const CATALOG_BY_ASIN = new Map(
  CATALOG.filter(p => p.asin).map(p => [p.asin, p])
);

/** O(1) ID lookup */
export const CATALOG_BY_ID = new Map(
  CATALOG.map(p => [p.id, p])
);

// ==============================
// UTILITY FUNCTIONS
// ==============================

/**
 * Filter catalog products matching quiz answers.
 * Returns up to `limit` products sorted by relevance.
 */
export function filterCatalogForQuiz({ recipient, occasion, interests, budget, limit = 80 }) {
  // Map quiz answers to tag values (includes aliases for hub page presets)
  const recipientTags = {
    boyfriend: ['him', 'boyfriend'],
    girlfriend: ['her', 'girlfriend'],
    husband: ['him', 'boyfriend'],
    wife: ['her', 'girlfriend'],
    dad: ['him', 'dad', 'fathersday'],
    father: ['him', 'dad', 'fathersday'],
    mom: ['her', 'mom', 'mothersday'],
    mother: ['her', 'mom', 'mothersday'],
    brother: ['him', 'teen'],
    sister: ['her', 'teen'],
    friend_male: ['him'],
    friend_female: ['her'],
    colleague: ['him', 'her'],
    teen_boy: ['him', 'teen'],
    teen_girl: ['her', 'teen'],
  };

  const budgetTags = {
    'under25': 'budget-under25',
    '25-50': 'budget-25-50',
    'under50': 'budget-under25',  // hub page alias — also enforced by price filter below
    '50-100': 'budget-50-100',
    '100-200': 'budget-100-200',
    '200plus': 'budget-200plus',
  };

  // Map occasion values to product tags (hub pages may use different names)
  const occasionAliases = {
    holiday: 'christmas',
    christmas: 'christmas',
    birthday: 'birthday',
    valentines: 'valentines',
    anniversary: 'valentines',   // anniversary gifts share valentine tags
    wedding: 'valentines',       // wedding gifts overlap with romantic tags
    graduation: 'birthday',     // graduation shares birthday-type gifts (no dedicated tag)
    mothersday: 'mothersday',
    fathersday: 'fathersday',
  };

  // Some occasions imply category interests for better filtering
  const occasionInterests = {
    graduation: ['tech', 'gaming'],   // grads typically get tech/practical gifts
    wedding: ['home'],                // wedding gifts are often home/kitchen items
  };

  // Budget price caps for hard price filtering
  const budgetMaxPrice = {
    'under25': 25,
    'under50': 50,
    '25-50': 50,
    '50-100': 100,
    '100-200': 200,
  };

  const wantedTags = new Set();

  // Add recipient tags
  const rTags = recipientTags[recipient] || ['him', 'her'];
  rTags.forEach(t => wantedTags.add(t));

  // Add occasion tag (with alias resolution)
  if (occasion) {
    const resolved = occasionAliases[occasion] || occasion;
    wantedTags.add(resolved);
    // Add implicit interest tags for certain occasions
    const impliedInterests = occasionInterests[occasion];
    if (impliedInterests) impliedInterests.forEach(t => wantedTags.add(t));
  }

  // Add interest tags
  if (interests && interests.length) {
    interests.forEach(i => wantedTags.add(i));
  }

  // Add budget tag
  const bTag = budgetTags[budget];
  if (bTag) wantedTags.add(bTag);

  // Hard price cap for budget-constrained queries
  const maxPrice = budgetMaxPrice[budget] || Infinity;

  // Score each product by how many wanted tags it matches
  const scored = CATALOG
    .filter(p => p.price > 0 && p.price <= maxPrice)
    .map(p => {
      let score = 0;
      for (const tag of p.tags) {
        if (wantedTags.has(tag)) score++;
      }
      return { product: p, score };
    })
    .filter(s => s.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored.slice(0, limit).map(s => s.product);
}

/**
 * Get catalog products with active discounts.
 * Returns products where discountPercent >= minDiscount.
 */
export function getCatalogDeals(minDiscount = 5) {
  return CATALOG.filter(p =>
    p.discountPercent && p.discountPercent >= minDiscount && p.salePrice
  );
}

/**
 * Fuzzy name match: find a catalog product matching a title string.
 * Used for post-processing AI quiz results.
 */
export function findProductByName(title) {
  if (!title) return null;
  const normalized = title.toLowerCase().trim();

  // 1. Exact match
  for (const p of CATALOG) {
    if (p.name.toLowerCase() === normalized) return p;
  }

  // 2. Substring match (catalog name in title or vice versa)
  //    Require the matching substring to be at least 8 chars to avoid short-name false positives
  let bestMatch = null;
  let bestLen = 0;
  for (const p of CATALOG) {
    const pName = p.name.toLowerCase();
    if ((normalized.includes(pName) || pName.includes(normalized)) && Math.min(pName.length, normalized.length) >= 8) {
      if (p.name.length > bestLen) {
        bestMatch = p;
        bestLen = p.name.length;
      }
    }
  }
  if (bestMatch) return bestMatch;

  // 3. Word overlap scoring — strict: exact word match only, min 3-char words on both sides
  const titleWords = normalized.split(/\s+/).filter(w => w.length >= 3);
  if (titleWords.length === 0) return null;

  // Extract brand from first word of title for brand-matching bonus
  const titleBrand = titleWords[0];

  let topScore = 0;
  let topProduct = null;
  for (const p of CATALOG) {
    const pWords = p.name.toLowerCase().split(/\s+/).filter(w => w.length >= 3);
    if (pWords.length === 0) continue;

    let overlap = 0;
    for (const tw of titleWords) {
      // Exact word match only (no substring matching within words)
      if (pWords.some(pw => pw === tw)) overlap++;
    }

    // Require at least 2 overlapping words to avoid single-word false positives
    if (overlap < 2) continue;

    // Score = overlap words / max(title words, catalog words) — penalize mismatched lengths
    const score = overlap / Math.max(titleWords.length, pWords.length);

    // Brand match bonus: if first word (brand) matches, boost score
    const brandMatch = pWords[0] === titleBrand ? 0.15 : 0;
    const finalScore = score + brandMatch;

    if (finalScore > topScore && finalScore >= 0.4) {
      topScore = finalScore;
      topProduct = p;
    }
  }

  return topProduct;
}

/**
 * Get the best affiliate link for a catalog product.
 * Prefers amznLink (direct short link), falls back to DP link.
 */
export function getProductLink(product) {
  if (product.amznLink) return product.amznLink;
  if (product.asin) return `https://www.amazon.com/dp/${product.asin}?tag=${AFFILIATE_TAG}`;
  return null;
}
